// extracted by mini-css-extract-plugin
module.exports = {"container":"ExpandableContentListBlock_container__pF2eh","blockList":"ExpandableContentListBlock_blockList__1q-BA","footer":"ExpandableContentListBlock_footer__2q2UW"};